import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Mentor from './components/Mentor';
import Challenge from './components/Challenge';
import Insights from './components/Insights';
import Mascot from './components/Mascot';
import './App.css';

const tabs = ['Mentor', 'Challenge', 'Insights'];

export default function App() {
  const [activeTab, setActiveTab] = useState('Mentor');
  const [userId] = useState('gracey');

  return (
    <div className="app">
      <div className="bg-blur-1" />
      <div className="bg-blur-2" />

      <header className="header">
        <div className="logo">
          <span className="logo-icon">⟳</span>
          <span className="logo-text">RecallCode</span>
        </div>
        <nav className="nav">
          {tabs.map(tab => (
            <button
              key={tab}
              className={`nav-btn ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
              {activeTab === tab && (
                <motion.div className="nav-indicator" layoutId="indicator" />
              )}
            </button>
          ))}
        </nav>
        <div className="user-pill">@{userId}</div>
      </header>

      <main className="main">
        <Mascot activeTab={activeTab} />
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -24 }}
            transition={{ duration: 0.35, ease: 'easeInOut' }}
            className="tab-content"
          >
            {activeTab === 'Mentor' && <Mentor userId={userId} />}
            {activeTab === 'Challenge' && <Challenge userId={userId} />}
            {activeTab === 'Insights' && <Insights userId={userId} />}
          </motion.div>
        </AnimatePresence>
      </main>
    </div>
  );
}